import { render, staticRenderFns } from "./recycle-list.vue?vue&type=template&id=613399fc&scoped=true&"
import script from "./recycle-list.vue?vue&type=script&lang=js&"
export * from "./recycle-list.vue?vue&type=script&lang=js&"
import style0 from "./recycle-list.vue?vue&type=style&index=0&id=613399fc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613399fc",
  null
  
)

export default component.exports